module.exports = __webpack_public_path__ + "static/about_us_bg-f5b6c005f0abe791c599faad47111082.png";